import $ from "jquery";
import app, { vuwer } from "@@assets/scripts/common";
import formImporter from "@@assets/form/importer";


// **** process ****
async function setForm() {
	await formImporter();
	
	/**********************
	*  setting component  *
	**********************/
	vuwer
	.add("fm", {
		vuwType: "jbForm",
		selector: "#fm",
		app,
		ACTION_URL: `${app.config.apipath}/contacts`,
		inputIdPrefix: "",
		autoInit: true,
		REST: true,
		
		// フォームの値が更新された後のコールバック
		onUpdate(item, config) {},
		
		// jsValidate実行時のコールバック
		// objErrorの中身は{count: エラー数, $elm: 最初のエラーの$オブジェクト（countが0の場合はnull）}
		onValidate($actvSheet, objError, config) {},
		
		// 確認シートへ値がコピーされる際のコールバック
		onCopyToConfirmSheet($cloneSheet, config) {},
		
		// submit成功コールバック
		onSubmitSuccess(config, res) {
			// 完了画面へメールアドレスをコピー
			$("#disp_email").text( $("#inp_email").val() );
		},
		
		onReady($self) {
			if(!$self) {
				return false;
			}
			
			this.$section = $self.closest(".section");
			
			return this._extendSheets()._extendFields();
		},
		
		/**
		 * データシートのカスタマイズ
		 * @returns this
		 */
		_extendSheets() {
			// 完了シートの中身を追加
			const finishSheet = this.getSheet("finish");
			finishSheet.$self.children(".finish-message").html(
				$("#finish_template").remove().html()
			);
			
			// 入力シートが変更になった際の処理
			this.$self.on("changeSheet", (e, currentSheet, nextSheet) => {
				// スクロール位置を上部へ
				vuwer._scrollBase = this.$section.offset().top - (
					vuwer.get("body").smoothScrollBuffer || 0
				);
				
				if(vuwer.$window.scrollTop() > vuwer._scrollBase) {
					$(document.scrollingElement).animate({
						scrollTop: vuwer._scrollBase
					}, "fast");
				}
				
				// クエリデータの更新
				if(nextSheet.name === "inputs") {
					delete app._GET.sheet;
				} else {
					app._GET.sheet = nextSheet.name;
				}
				app.replaceState( Object.assign({}, app._GET) );
			});
			
			return this;
		},
		
		/**
		 * 入力フィールドのカスタマイズ
		 * @returns this
		 */
		_extendFields() {
			// [agreement] 同意ボタンに連動してbtn-nextの押下可・不可を変更する
			const inputsSheet = this.getSheet("inputs");
			// btn-next: 初期表示時は押下不可にする
			const $btn = inputsSheet.$btns.children(".btn-next").addClass("is-disable");
			if($btn.length) {
				const { agreement } = this.getField();
				agreement.$inp.on("change", e => {
					$btn.toggleClass("is-disable", !e.currentTarget.checked);
				});
			}
			
			// [for Mobile] 入力時にscrollToPageTopを隠す
			if(app.device[0] === "sp") {
				this.$self
				.on("focus", ".inp", e => {
					vuwer.get("scrollToPageTop").setState("visible", false);
				})
				.on("blur", ".inp", e => {
					vuwer.get("scrollToPageTop").setState("visible", true);
				});
			}
			
			return this;
		}
	}, function() {
		// appから直接アクセス可能にする
		app.fm = this;
	});
	
	return vuwer.get("fm");
}

export default setForm;
